import { c as _c } from "react/compiler-runtime";
import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { FullPageSpinner } from "../../shared/layout/FullPageSpinner/FullPageSpinner";
import { LoginError, LoginErrorConfig } from "./LoginError/LoginError";
type PromptValues = "login" | "consent" | "none" | "select_account" | undefined;
export const UserWrapper: React.FC<{
  children: React.ReactNode;
  siteTitle: string;
  loginErrorConfig: LoginErrorConfig;
  skipAuthentication?: boolean;
}> = t0 => {
  const $ = _c(7);
  const {
    children,
    siteTitle,
    loginErrorConfig,
    skipAuthentication: t1
  } = t0;
  const skipAuthentication = t1 === undefined ? false : t1;
  const {
    isLoading,
    isAuthenticated,
    loginWithRedirect,
    user,
    error
  } = useAuth0();
  let screenHint;
  let loginHint;
  let prompt;
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    screenHint = urlParams.get("screen_hint");
    prompt = urlParams.get("prompt") as PromptValues;
    loginHint = urlParams.get("login_hint");
  }
  if (!isAuthenticated && !isLoading && !error && !skipAuthentication) {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: screenHint ? screenHint : undefined,
        login_hint: loginHint ? loginHint : undefined,
        prompt: prompt ? prompt : undefined
      }
    });
  }
  if (error) {
    let t2;
    if ($[0] !== error.message || $[1] !== loginErrorConfig || $[2] !== siteTitle) {
      t2 = <LoginError message={error.message} siteTitle={siteTitle} loginErrorConfig={loginErrorConfig} />;
      $[0] = error.message;
      $[1] = loginErrorConfig;
      $[2] = siteTitle;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (!user && !skipAuthentication) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <FullPageSpinner />;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t2;
  if ($[5] !== children) {
    t2 = <>{children}</>;
    $[5] = children;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};